export default "__VITE_ASSET__Cd7bDIG3__"